/**
 * @ngdoc controller
 * @name TosController
 * @description
 * This component renders the Tos section.
 *
 * @memberof account
 */
class TosController {
  /**
   * Class constructor.
   * @param {Service} $http        To get the TOS text from the server.
   * @param {Service} $location    To redirect when accepted tos process finishes.
   * @param {Service} ccaSession   To mark the TOS as accepted by the current user.
   * @param {Service} errorHandler To show any errors.
   * @ignore
   */
  constructor(
    $http,
    $location,
    ccaSession,
    errorHandler,
  ) {
    'ngInject';

    /**
     * The local reference to the `$http` service.
     * @type {Object}
     */
    this.$http = $http;
    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `ccaSession` service.
     * @type {Object}
     */
    this.ccaSession = ccaSession;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `user` object.
     * @type {Object}
     */
    this.user = ccaSession.getUser();
    /**
     * The local reference to the `account` object.
     * @type {Object}
     */
    this.account = ccaSession.getSelectedAccount();
    /**
     * The local reference to the `accept` input.
     * @type {Boolean}
     */
    this.accept = false;
    /**
     * To show an error or not.
     * @type {Boolean}
     */
    this.error = false;
    /**
     * The TOS text to display.
     * @type {?String}
     */
    this.tosText = null;
  }
  /**
   * If the TOS type is text then get the text from the server.
   */
  $onInit() {
    if (this.account.customer.tos.url_interpretation === 'text') {
      this.$http.get(this.account.customer.tos.url)
      .then((response) => {
        this.tosText = response.data;
      })
      .catch(() => {
        this.errorHandler.showErrorMessage('Couldn\'t read the TOS file from the server.');
        // Set the default TOS
        this.account.customer.tos.url_interpretation = 'link';
        this.account.customer.tos.url = 'http://www.olapic.com/tos/';
      });
    }
  }
  /**
   * Handle the continue action.
   * Mark the TOS as accepted by the current user and redirect to the home page.
   * If the user didn't accepted the TOS, display an error.
   */
  continue() {
    if (!this.accept) {
      this.error = true;
      return;
    }

    this.ccaSession.setTosAccepted()
    .then(() => {
      this.$location.url('/');
    });
  }
}

export default TosController;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/tos/tos.controller.js